import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter()
const username = ref('')
const password = ref('')
const showPassword = ref(false)
const store = useStore()

const responseAuth = computed(() => store.state.Auth.responseAuth)

const loading = ref(false)

const login = async () => {
  loading.value = true;
  const formData = new FormData()
  formData.append('username',username.value ?? '')
  formData.append('password', password.value)
  await store.dispatch('Auth/login', formData)

  if (responseAuth.value?.success) {
    localStorage.setItem('token', responseAuth.value.token)
    router.push('/dashboard')
  }
  loading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "fill-height d-flex justify-center align-center" }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(login, ["prevent"])
      }, [
        _createVNode(_component_v_card, {
          loading: loading.value,
          class: "pa-6",
          width: "400"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h6" }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Iniciar sesión")
              ])),
              _: 1,
              __: [3]
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: username.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
                  label: "Usuario"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  modelValue: password.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                  label: "Contraseña",
                  autocomplete: "off",
                  type: showPassword.value ? 'text' : 'password',
                  "append-inner-icon": showPassword.value ? 'mdi-eye' : 'mdi-eye-off',
                  "onClick:appendInner": _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value))
                }, null, 8, ["modelValue", "type", "append-inner-icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  block: "",
                  color: "primary",
                  type: "submit"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Entrar")
                  ])),
                  _: 1,
                  __: [4]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"])
      ], 32)
    ]),
    _: 1
  }))
}
}

})